module.exports = "/assets/data/fe5beed71b4dde5f3329f07900094766-NW6.data.json";